<template>
  <div class="alarmas">
    <b-row v-if="acsPanel">
      <b-col>
        <div class="accordion my-4">
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button
                class="accordion-button"
                :class="legendHidden ? '' : 'collapsed'"
                type="button"
                @click="cambiarAcordion"
              >
                <span :class="legendHidden? 'text-primary':'text-secondary'">
                    <i class="fas fa-info-circle me-2"></i>
                    {{ legendHidden
                    ? "Mostrar información"
                    : "Ocultar información"
                }}</span>
              </button>
            </h2>
            <div
              class="accordion-collapse"
              id="acordion-content"
              :hidden="legendHidden"
            >
              <div class="accordion-body">
                <p class="text-primary mb-0">Estados de las alarmas</p>
                <ul>
                    <li><span class="fw-bold">Activa:</span> Una alarma está activa cuando se produce un cortocircuito</li>
                    <li><span class="fw-bold">No activa:</span> Una alarma activa pasará a estar no activa cuando el sensor detecta que ya no hay cortocircuito</li>
                    <li><span class="fw-bold">Atendida:</span> Una alarma activa pasará a estar atendida cuando un operario ha marcado la alarma como atendida y se dispone a resolver el incidente</li>
                </ul>
                <p class="text-primary mb-0">Flujo de los estados</p>
                <ul>
                    <li>Cuando se origina un cortocircuito, la alarma asociada aparecerá con estado <span class="fw-bold">Activa</span> por defecto</li>
                    <li>Una alarma <span class="fw-bold">Activa</span> puede pasar a estado <span class="fw-bold">No activa</span> o a estado <span class="fw-bold">Atendida</span></li>
                    <li>Una alarma <span class="fw-bold">Atendida</span> puede pasar a estado <span class="fw-bold">No activa</span> pero <span class="fw-bold">no puede volver a estado Activa</span></li>
                    <li>Una alarma <span class="fw-bold">No activa</span> puede volver a estado <span class="fw-bold">Activa</span> pero <span class="fw-bold">no puede pasar a estado Atendida</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <notification-list></notification-list>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Notificationlist from "@/components/notification/NotificationList";

export default {
  data() {
    return {
      legendHidden: true,
      acsPanel: null
    };
  },
  components: {
    "notification-list": Notificationlist,
  },
  mounted(){
    this.acsPanel = process.env.VUE_APP_PROJECT_ACRONYM == "acs";
  },
  methods: {
    cambiarAcordion(){
      this.legendHidden = !this.legendHidden;
    }
  }
};
</script>

<style>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>